// src/pages/HRAdmin/Position/EditPositionPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper
} from '@mui/material';

function EditPositionPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    description: '',
  });

  useEffect(() => {
    api
      .get(`/positions/${id}`)
      .then((res) => {
        const pos = res.data;
        setFormData({
          name: pos.name || '',
          code: pos.code || '',
          description: pos.description || '',
        });
      })
      .catch((err) => console.error('Failed to load position:', err));
  }, [id]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .put(`/positions/${id}`, formData)
      .then(() => navigate('/admin/positions'))
      .catch((err) => console.error('Error updating position:', err));
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Edit Position
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Position Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          fullWidth
          margin="normal"
        />
        <TextField
          label="Code"
          name="code"
          value={formData.code}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => navigate('/admin/positions')}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Save Changes
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

export default EditPositionPage;
